var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expense",
    transform: "translate(2755 -5635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    transform: "translate(-2755 5635)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-2748 5642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M33.5,45.487h32.49V3H31V42.987A2.5,2.5,0,0,0,33.5,45.487Z",
    transform: "translate(6.989)",
    fill: "#4e901e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M59.992,10.749V44.488H35V10.749A3.749,3.749,0,0,0,38.749,7H56.243A3.749,3.749,0,0,0,59.992,10.749Z",
    transform: "translate(7.987 0.998)",
    fill: "#7ed63e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M55,45.488h5V8a41.744,41.744,0,0,1-5,19.972Z",
    transform: "translate(12.98 1.248)",
    fill: "#46821b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M40.909,40.249H58.517V23.983A36.189,36.189,0,0,1,40.909,40.249Z",
    transform: "translate(9.462 5.237)",
    fill: "#71c138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M70.883,45.644a3.741,3.741,0,0,0,1.09-2.924,3.894,3.894,0,0,0-3.95-3.474H36.994a2.5,2.5,0,0,1-2.5-2.5V28H31.78a2.5,2.5,0,0,0-1.767.732l-7.283,7.283a2.5,2.5,0,0,1-1.767.732H17V65.488h4.165a2.5,2.5,0,0,1,1.5.5l3.666,2.749a2.5,2.5,0,0,0,1.5.5H60.736a3.749,3.749,0,0,0,0-7.5h2.5a3.749,3.749,0,1,0,0-7.5h2.5a3.749,3.749,0,0,0,0-7.5h2.5a3.74,3.74,0,0,0,2.649-1.1Z",
    transform: "translate(3.494 6.24)",
    fill: "#ffbcab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M3,32H20.494V68.239H3Z",
    transform: "translate(0 7.239)",
    fill: "#006df0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(9 65)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M55,37h0Z",
    transform: "translate(12.98 8.487)",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    height: 25,
    transform: "translate(55 33)",
    fill: "#9bc9ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(48 25)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M45.25,19.5a1.25,1.25,0,0,0,1.25-1.25v-5a1.25,1.25,0,1,0-2.5,0v5A1.25,1.25,0,0,0,45.25,19.5Z",
    transform: "translate(10.234 2.246)",
    fill: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(51.735 51.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M64.643,42.15c.045-.045.079-.1.125-.15H42v1.25H61.994a3.74,3.74,0,0,0,2.649-1.1Z",
    transform: "translate(-42 -42)",
    fill: "#ff9478"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M42,49.25H59.494a3.74,3.74,0,0,0,2.649-1.1c.046-.046.08-.1.125-.15H42Z",
    transform: "translate(-42 -40.502)",
    fill: "#ff9478"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M42,55.25H57a3.74,3.74,0,0,0,2.649-1.1c.046-.046.08-.1.125-.15H42Z",
    transform: "translate(-42 -39.005)",
    fill: "#ff9478"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense);
export default __webpack_public_path__ + "static/media/expense.04bf7abcf791d28d287493de06df756a.svg";
export { ForwardRef as ReactComponent };